import { useEffect, useState } from "react";
import { DOLOPALS, MISSIONS, SHOP_ITEMS } from "../../data/dolopals";
import { normalizeExp, signalOfTheDay, titanLevel } from "./utils";
import { sfx } from "./audio";

const XP_KEY = "dolopals-expeditions";

const loadExp = () => {
  try {
    return normalizeExp(JSON.parse(localStorage.getItem(XP_KEY)));
  } catch {
    return normalizeExp(null);
  }
};

export function useExpeditions() {
  const [exp, setExp] = useState(loadExp);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    localStorage.setItem(XP_KEY, JSON.stringify(exp));
    window.dispatchEvent(new CustomEvent("dolo-expeditions", { detail: exp }));
  }, [exp]);

  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, []);

  const send = (titanId, missionId) => {
    setExp((e) => {
      if (e.active[titanId]) return e;
      const mission = MISSIONS.find((m) => m.id === missionId);
      if (!mission) return e;
      sfx("/assets/game-coin.wav", 0.4);
      return { ...e, active: { ...e.active, [titanId]: { missionId, endsAt: Date.now() + mission.seconds * 1000 } } };
    });
  };

  const claim = (titanId) => {
    setExp((e) => {
      const run = e.active[titanId];
      if (!run) return e;
      const mission = MISSIONS.find((m) => m.id === run.missionId);
      const pal = DOLOPALS.find((p) => p.id === titanId);
      if (!mission || !pal) return e;
      const match = pal.trait === mission.trait;
      const level = titanLevel(e.xp[titanId]);
      const base = mission.shards[0] + Math.floor(Math.random() * (mission.shards[1] - mission.shards[0] + 1));
      const sotd = run.missionId === signalOfTheDay();
      const shards = Math.round(base * (match ? 1.5 : 1) * (1 + 0.05 * (level - 1))) * (sotd ? 2 : 1);
      const xpGain = Math.round(mission.xp * (match ? 1.25 : 1));
      const gotFragment = mission.fragment ? (match || Math.random() < 0.25) : false;
      const active = { ...e.active };
      delete active[titanId];
      sfx(match ? "/assets/game-blast.wav" : "/assets/game-coin.wav", 0.5);
      return {
        ...e,
        shards: e.shards + shards,
        fragments: e.fragments + (gotFragment ? 1 : 0),
        xp: { ...e.xp, [titanId]: (e.xp[titanId] || 0) + xpGain },
        active,
      };
    });
  };

  const buy = (itemId) => {
    setExp((e) => {
      const item = SHOP_ITEMS.find((i) => i.id === itemId);
      if (!item || e.shards < item.cost || e.owned.includes(itemId)) return e;
      sfx("/assets/game-coin.wav", 0.5);
      return { ...e, shards: e.shards - item.cost, owned: [...e.owned, itemId] };
    });
  };

  const equip = (itemId) => {
    setExp((e) => {
      const item = SHOP_ITEMS.find((i) => i.id === itemId);
      if (!item || !e.owned.includes(itemId)) return e;
      const key = item.kind;
      sfx("/assets/game-coin.wav", 0.3);
      return { ...e, [key]: e[key] === itemId ? null : itemId };
    });
  };

  return { exp, now, send, claim, buy, equip, setExp };
}
